import FEATURES from "../../config/features";

// Prefer the dashboard, then follow the navigation order. Only choose routes
// whose permission level and account feature requirements are satisfied.
export function getLandingPage({ canView, canEdit, user }) {
  const extras = (user?.details?.product || "").split(",").includes("extras");
  const crm = (user?.flags || []).some((flag) => flag.name === "crm");
  const pages = [
    ["dashboard", "/"],
    ["messaging.messages", "/messages"],
    ["messaging.guests", "/guests"],
    ["messaging.contacts", "/contacts"],
    ["crm.contacts", "/crm"],
    ["crm.pipelines", "/crm/pipelines"],
    ["admin.integrations", "/smart-locks"],
    ["guides.payments", "/orders", extras],
    ["messaging.scheduler", "/scheduler"],
    ["messaging.extend_stay", "/extend-guest-stay"],
    ["messaging.alerts", "/alerts"],
    ["messaging.surveys", "/surveys"],
    ["messaging.responses", "/saved-responses"],
    ["messaging.templates", "/message-templates"],
    ["messaging.chatbot", "/chatbot-faqs"],
    ["messaging.ai", "/ai-assistant"],
    ["operations.property_defaults", "/operations/property-defaults"],
    ["operations.calendar", "/operations"],
    ["operations.work_orders", "/work-orders"],
    ["operations.inventory", "/operations/storage"],
    ["operations.surveys", "/operations/survey-board"],
    ["operations.inspections", "/operations/inspection-board", FEATURES.INSPECTIONS_ENABLED],
    ["operations.checklists", "/operations/checklists", FEATURES.CHECKLISTS_ENABLED],
    ["operations.work_schedules", "/work-schedules"],
    ["operations.standards", "/operations/standards-structure", FEATURES.CLEANING_STANDARDS_ENABLED, "edit"],
    ["operations.standards", "/operations/property-setup", FEATURES.PROPERTY_SETUP_ENABLED, "edit"],
    ["guides.master", "/guide-designer", true, "edit"],
    ["guides.home", "/properties"],
    ["guides.area", "/areas"],
    ["guides.extras", "/extras", extras],
    ["guides.master", "/subscriptions"],
    ["operations.tasks", "/tasks"],
    ["reports", "/reports"],
    ["crm.notes", "/notes"],
    ["crm.custom_fields", "/custom-fields", crm],
    ["admin.units", "/units"],
    ["admin.macros", "/macros"],
    ["admin.zones", "/zones"],
    ["admin.settings", "/settings"],
    ["admin.users", "/team"],
    ["admin.roles", "/roles"],
    ["admin.billing", "/billing"],
  ];
  const available = pages.find(([module, , enabled = true, level = "view"]) =>
    enabled && (level === "edit" ? canEdit(module) : canView(module)),
  );
  // Profile is available to every authenticated user, including users whose
  // role has no section access. Login itself is never an access violation.
  return available?.[1] || "/profile";
}
